// extracted by mini-css-extract-plugin
export var callCard = "_m9-0";
export var callMessageButton = "_m9-1";
export var helpIcon = "_m9-3";
export var helpIconContainer = "_m9-4";
export var verticalDivider = "_m9-2";